import FooterHelp from './FooterHelp';
import GreetingHeading, { EmptyStateTone } from './GreetingHeading';
import Motif, { MotifKind } from './Motif';
import NotifyForm from './NotifyForm';

interface CenteredLayoutProps {
  motif: MotifKind;
  tone: EmptyStateTone;
  submitted: boolean;
  onSubmit: () => void;
  name?: string;
}

const CenteredLayout = ({ motif, tone, submitted, onSubmit, name }: CenteredLayoutProps) => (
  <div className="flex-1 flex items-center justify-center p-12 min-h-0">
    <div className="max-w-[640px] w-full text-center flex flex-col items-center gap-7">
      <Motif kind={motif} />
      <div>
        <GreetingHeading tone={tone} submitted={submitted} name={name} />
      </div>
      <NotifyForm submitted={submitted} onSubmit={onSubmit} />
      <FooterHelp />
    </div>
  </div>
);

export default CenteredLayout;
